import { render, staticRenderFns } from "./KoPollutantsSubTable.vue?vue&type=template&id=2f680e4e"
import script from "./KoPollutantsSubTable.vue?vue&type=script&lang=js"
export * from "./KoPollutantsSubTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports